<template>
  <div class="zt-avatar items-center justify-center inline-flex rounded-full w-10 h-10 m-1 align-middle"
    :class="avatarClasses" :style="avatarStyle" ref="ztAvatar">
    <div v-if="src" class="overflow-hidden rounded-full w-full h-full">
      <img :src="src" alt="" />
    </div>
    <span v-else :title="text" :style="textStyleScale" class="font-black leading-normal tracking-normal text-zt-lg"
      ref="ztAvatarText">
      {{ textAvatar }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'ztAvatar',
  inheritAttrs: false,
}
</script>


